import { TenantPreference } from "../../Models/TenantPreference";
import api from "../axios";

export const tenantPreferenceService = {
  get: async (): Promise<TenantPreference> => {
    const response = await api.get('/tenant-preference');
    return response.data;
  },

  update: async (data: TenantPreference): Promise<boolean> => {
    const response = await api.put('/tenant-preference', data);
    return response.data;
  }
};
